import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=3e5228fa&scoped=true"
import script from "./Interface.vue?vue&type=script&lang=js"
export * from "./Interface.vue?vue&type=script&lang=js"
import style0 from "./Interface.vue?vue&type=style&index=0&id=3e5228fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5228fa",
  null
  
)

export default component.exports